var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", { staticClass: "is-size-6 w-180" }, [
      _vm._v(_vm._s(_vm.group.slug)),
    ]),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "is-size-6" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: `/admin/posts/${_vm.serviceId}/groups/${_vm.group.slug}`,
            },
          },
          [_vm._v(_vm._s(_vm.group.label))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }